import { Icons } from '@/app/components/ui/Icons'
import { HOTEL_SKELETON_IMAGE } from '@/app/constants'
import classNames from 'classnames'
import Image from 'next/image'
import { FC } from 'react'

const renderStars = () => {
	return (
		<div className="hotel-card-placeholder__stars flex mb-2 ">
			{[...Array(5)].map((_, i) => (
				<Icons.star
					key={i}
					fill="#E2E8F0"
					className="w-4 h-4 rounded-full mr-1"
				/>
			))}
		</div>
	)
}

const HotelListItemPlaceholder: FC = () => {
	return (
		<>
			<div className="hotel-card-placeholder flex max-lg:flex-col lg:p-2 bg-white rounded-4xl shadow-md border border-text-300">
				{/* Image column */}
				<div className="w-full shrink-0 lg:w-[190px] xlg:w-[280px] lg:mr-6 rounded-4xl overflow-hidden">
					<Image
						src={HOTEL_SKELETON_IMAGE}
						width={280}
						height={220}
						alt={'placeholder image'}
						className="animate-placeholder max-lg:!h-[170px] max-lg:w-full lg:max-xlg:h-[220px] object-cover"
					/>
				</div>

				{/* Content column */}
				<div className="w-full lg:min-w-[211px] lg:max-xlg:grow xlg:w-[524px] flex flex-col justify-between max-lg:px-4 max-lg:py-3">
					<div>
						<div className="flex max-lg:flex-col-reverse max-lg:items-start justify-between items-center">
							<div className="w-full">
								<div className="xlg:hidden">{renderStars()}</div>
								<div className="hotel-card-placeholder__title h-5 bg-text-300 rounded-4xl w-3/4 lg:w-[286px] mb-2"></div>
							</div>
							<div className="max-xlg:hidden">{renderStars()}</div>
						</div>
						<div className="flex items-center mb-2 max-lg:flex-col max-lg:justify-start max-lg:items-start">
							<div className="flex items-center">
								<div className="rounded w-4 h-4 bg-text-300 mr-1 animate-placeholder" />
								<div className="h-3 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
								<div className="h-3 w-[100px] bg-text-300 rounded-4xl animate-placeholder "></div>
							</div>
							<div className="max-lg:mt-4 flex lg:hidden">
								<div className="h-3 w-[100px] bg-text-300 rounded-4xl animate-placeholder mr-2"></div>
								<div className="h-3 w-[100px] bg-text-300 rounded-4xl animate-placeholder"></div>
							</div>
						</div>
					</div>

					<div className="flex max-lg:pb-3 max-lg:border-b border-text-200">
						<div className="h-6 w-[80px] bg-text-300 rounded-lg me-2 animate-placeholder" />
						<div className="h-6 w-[80px] bg-text-300 rounded-lg animate-placeholder" />
					</div>

					<div className="flex items-center justify-between lg:hidden mt-3 rounded-4xl bg-white">
						<div className="flex flex-col">
							<div className="h-3 w-[74px] bg-text-300 rounded-4xl mb-1 animate-placeholder"></div>
							<div className="h-3 w-[81px] bg-text-300 rounded-4xl animate-placeholder "></div>
						</div>
						<div className="rounded-4xl w-[74px] h-4 bg-text-300 mr-1 animate-placeholder" />
					</div>

					<div className="hidden lg:flex justify-between space-x-2 border border-text-200 rounded-2xl p-2">
						{[1, 2, 3].map((_, i) => (
							<div
								key={i}
								className={classNames('relative flex items-center w-full')}
							>
								<div className="flex flex-col items-center p-1.5 mx-auto">
									<div className="w-16 h-3 bg-text-300 rounded-full mb-1 animate-placeholder"></div>
									<div className="w-9 h-3 bg-text-300 rounded-4xl animate-placeholder"></div>
								</div>
							</div>
						))}
					</div>
				</div>

				{/* View deal column */}
				<div className="hidden lg:max-xlg:max-w[230px] lg:max-w-[230px] lg:flex flex-col justify-between items-start ms-8 lg:max-xlg:ms-4 ">
					<div className="flex items-center mb-2">
						<div className="w-8 h-8 bg-text-300 rounded-3xl  rounded-br mr-2"></div>
						<div className="flex flex-col gap-1">
							<div className="w-[60px] h-3 bg-text-300 rounded-4xl"></div>
							<div className="h-3 w-[80px] bg-text-300 rounded-4xl"></div>
						</div>
					</div>
					<div>
						<div className="hotel-card-placeholder__price h-5 bg-text-300 rounded-4xl w-24 mb-2"></div>
						<div className="hotel-card-placeholder__price h-3 w-[150px] bg-text-300 rounded-4xl"></div>
					</div>
					<div className="flex w-full">
						<div className="hotel-card-placeholder__button h-11 bg-text-300 rounded-full w-full"></div>
					</div>
				</div>
			</div>
		</>
	)
}

export default HotelListItemPlaceholder
